import { Box } from '@mui/material';
import React from 'react';
import type BackendService from '../../../services/admin/BackendService';
import { PALETTE_BLOCKS } from './blockPaletteBlocks';
import type { SidebarTab } from './editorSidebarContext';
import MediaLibraryDocumentsTab from './MediaLibraryDocumentsTab';
import MediaLibraryTab from './MediaLibraryTab';
import PaletteBlockCard from './PaletteBlockCard';

interface PaletteTabBodyProps {
  open: boolean;
  tab: SidebarTab;
  isNarrow: boolean;
  fundOpportunityId: string;
  backendService: BackendService;
  modelType: string;
  modelId: string;
}

/** Scrollable body for the active Blocks / Media / Documents tab. */
export default function PaletteTabBody({
  open,
  tab,
  isNarrow,
  fundOpportunityId,
  backendService,
  modelType,
  modelId,
}: PaletteTabBodyProps) {
  if (!open) return null;
  return (
    <Box
      sx={{
        flex: 1,
        // Without this, a flex item's default min-width:auto lets a long unwrapped title
        // further down win over its own width:100%, inflating this whole column wider than
        // the drawer instead of being clamped and truncated.
        minWidth: 0,
        overflowY: 'auto',
        p: 1.5,
        display: 'flex',
        gap: 1.5,
        flexDirection: isNarrow ? 'row' : 'column',
        overflowX: isNarrow ? 'auto' : 'hidden',
      }}
    >
      {tab === 'blocks' ? (
        PALETTE_BLOCKS.map((block) => (
          <Box key={block.type} sx={isNarrow ? { flex: '0 0 260px' } : undefined}>
            <PaletteBlockCard block={block} />
          </Box>
        ))
      ) : tab === 'media' ? (
        <MediaLibraryTab
          fundOpportunityId={fundOpportunityId}
          backendService={backendService}
          isNarrow={isNarrow}
        />
      ) : (
        <MediaLibraryDocumentsTab
          fundOpportunityId={fundOpportunityId}
          backendService={backendService}
          isNarrow={isNarrow}
          modelType={modelType}
          modelId={modelId}
        />
      )}
    </Box>
  );
}
